import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const ThemeContext = createContext(null);
export const ThemeProvider = ({ theme, children }) => (_jsx(ThemeContext.Provider, { value: theme, children: children }));
//# sourceMappingURL=index.js.map